import { InMemoryCache } from "@apollo/client";

export const createApolloCache = () =>
  new InMemoryCache({
    typePolicies: {
      Post: {
        // Utiliser l'ID composite pour le cache
        keyFields: ["id"],
      },
      Group: {
        // Utiliser l'ID composite pour le cache
        keyFields: ["id"],
      },
      /**
       * Un Context est embarqué dans son Group et son id n'est unique qu'au
       * sein de ce Group (ex. `ctx-depenses` dans deux foyers). Normalisé par
       * son seul id, deux foyers partageant un contextId fusionnaient dans la
       * même entrée de cache et l'un écrasait les posts de l'autre (#626).
       */
      Context: { keyFields: false },
      // BilanItem et BilanItems sont des objets calculés à la volée,
      // spécifiques à une date. Sans keyFields: false, Apollo normalise
      // ces objets par leur id et les partage entre les requêtes de
      // différentes dates — ce qui provoque l'affichage de montants
      // périmés lors d'un changement de date.
      BilanItems: { keyFields: false },
      BilanItem: { keyFields: false },
    },
  });
